module.exports = __webpack_public_path__ + "img/i_arena_TOP_off.5317f11.png";